/*eslint-disable*/ export const messages = JSON.parse("{\"toast.aria.error\":[\"Error\"],\"toast.aria.successful\":[\"Successful\"],\"toast.aria.warning\":[\"Warning\"]}");
//# sourceMappingURL=messages.mjs.map